'use client';
import { useState } from 'react';
import Button from '@/components/ui/Button';

export default function HeroSection() {
    const [currentSlide, setCurrentSlide] = useState(0)
    const totalSlides = 3

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides)
    }

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides)
    }

    return (
        <section className="w-full relative">
            <div
                className="w-full bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: 'url(/images/img_rectangle_3.webp)' }}
            >
                <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px] pt-10 sm:pt-14 lg:pt-[76px] pb-24 sm:pb-28 lg:pb-[140px]">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12 relative">
                        {/* Left Navigation Button */}
                        <button
                            onClick={prevSlide}
                            className="hidden lg:block absolute left-0 top-1/2 -translate-y-1/2 w-[50px] h-[50px] lg:w-[70px] lg:h-[70px] bg-background-main rounded-[34px] shadow-[0px_0px_16px_#00000019] hover:bg-background-secondary transition-all duration-200 z-10"
                            aria-label="Previous slide"
                        >
                            <svg className="w-6 h-6 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>

                        {/* Hero Content */}
                        <div className="w-full lg:w-[90%] mx-auto flex flex-col gap-6 sm:gap-8 lg:gap-[40px]">
                            <div className="flex flex-col gap-3 sm:gap-5 lg:gap-6">
                                <p className="text-sm sm:text-base lg:text-[21px] text-text-primary font-semibold leading-5 sm:leading-6 lg:leading-[27px] uppercase tracking-wider">
                                    New Collection 2026
                                </p>

                                <h1 className="text-[32px] sm:text-[52px] md:text-[70px] lg:text-[86px] text-text-primary font-semibold leading-[38px] sm:leading-[60px] md:leading-[84px] lg:leading-[105px]">
                                    Elevate Your<br />Everyday Style
                                </h1>

                                <p className="text-sm sm:text-base lg:text-[21px] text-text-primary font-medium leading-5 sm:leading-6 lg:leading-7xl mt-2 sm:mt-4 lg:mt-6">
                                    Discover the latest trends in fashion. Premium<br className="hidden sm:inline" />quality, modern designs, made for you
                                </p>

                                {/* Call to Action Buttons */}
                                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-4 sm:mt-6 lg:mt-[36px]">
                                    <Button
                                        variant="primary"
                                        size="md"
                                        onClick={() => { }}
                                        className="bg-primary-brand text-text-on-dark text-sm sm:text-base lg:text-md font-medium rounded-xs px-6 sm:px-8 lg:px-[32px] py-3 sm:py-3.5 lg:py-[14px] gap-[10px] hover:bg-primary-brand-dark transition-colors duration-200 justify-center"
                                    >
                                        Shop Now
                                        <img
                                            src="/images/img_arrowright.svg"
                                            alt=""
                                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 lg:w-[16px] lg:h-[16px]"
                                        />
                                    </Button>

                                    <button className="border border-text-secondary text-text-secondary text-sm sm:text-base lg:text-md font-semibold rounded-xs px-4 sm:px-5 lg:px-[16px] py-3 sm:py-3 lg:py-[12px] hover:bg-text-secondary hover:text-text-on-dark transition-all duration-200 text-center">
                                        Explore Collection
                                    </button>
                                </div>
                            </div>

                            {/* Slide Indicators (3 Dots) */}
                            <div className="flex flex-row gap-2.5 sm:gap-3 items-center justify-center lg:justify-start pt-2">
                                {[0, 1, 2].map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => setCurrentSlide(index)}
                                        className={`rounded-full transition-all duration-300 ${currentSlide === index
                                                ? 'w-3.5 h-3.5 sm:w-4 sm:h-4 bg-text-primary scale-110 shadow-sm'
                                                : 'w-3 h-3 sm:w-3.5 sm:h-3.5 border-2 border-text-primary bg-transparent hover:bg-black/20'
                                            }`}
                                        aria-label={`Go to slide ${index + 1}`}
                                        aria-current={currentSlide === index}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* Right Navigation Button */}
                        <button
                            onClick={nextSlide}
                            className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 w-[50px] h-[50px] lg:w-[70px] lg:h-[70px] bg-background-main rounded-[34px] shadow-[0px_0px_16px_#00000019] hover:bg-background-secondary transition-all duration-200 z-10"
                            aria-label="Next slide"
                        >
                            <svg className="w-6 h-6 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}